export const ads = [
  {
    "pdf": "pdf/ad-1.pdf",
    "sp": [
      {
        "name": "マイクロトラック・ベル株式会社",
        "url": "https://www.microtrac.com/jp/"
      }
    ],
    "tn": "tn/ad-1.jpg"
  },
  {
    "pdf": "pdf/ad-2.pdf",
    "sp": [
      {
        "name": "BCSJ Chem. Lett.",
        "url": "https://www.journal.csj.jp/journal/cl"
      }
    ],
    "tn": "tn/ad-2.jpg"
  },
  {
    "pdf": "pdf/ad-3.pdf",
    "sp": [
      {
        "name": "ブルカージャパン株式会社",
        "url": "https://www.bruker.com/ja.html"
      }
    ],
    "tn": "tn/ad-3.jpg"
  },
  {
    "pdf": "pdf/ad-4.pdf",
    "sp": [
      {
        "name": "株式会社リガク",
        "url": "https://japan.rigaku.com/ja"
      }
    ],
    "tn": "tn/ad-4.jpg"
  },
  {
    "pdf": "pdf/ad-5.pdf",
    "sp": [
      {
        "name": "株式会社ブライト",
        "url": "https://bright-jp.com"
      }
    ],
    "tn": "tn/ad-5.jpg"
  },
  {
    "pdf": "pdf/ad-6.pdf",
    "sp": [
      {
        "name": "株式会社ユニソク",
        "url": "https://www.unisoku.co.jp"
      }
    ],
    "tn": "tn/ad-6.jpg"
  },
  {
    "pdf": "pdf/ad-7.pdf",
    "sp": [
      {
        "name": "ビー・エー・エス株式会社",
        "url": "https://bas.co.jp"
      }
    ],
    "tn": "tn/ad-7.jpg"
  },
  {
    "pdf": "pdf/ad-8.pdf",
    "sp": [
      {
        "name": "旭化学工業株式会社",
        "url": "http://www.chem-asahi.co.jp"
      }
    ],
    "tn": "tn/ad-8.jpg"
  },
  {
    "pdf": "pdf/ad-9.pdf",
    "sp": [
      {
        "name": "Royal Society of Chemistry",
        "url": "https://rsc.li/Dalton"
      }
    ],
    "tn": "tn/ad-9.jpg"
  },
  {
    "pdf": "pdf/ad-10.pdf",
    "sp": [
      {
        "name": "BCSJ Chem. Lett.",
        "url": "https://www.journal.csj.jp/journal/cl"
      }
    ],
    "tn": "tn/ad-10.jpg"
  }
]
;
